const TABLET_BREAKPOINT = 768;

export type GameTileSize = {
    mobile: number;
    tablet: number;
};

export const DEFAULT_GAME_TILE_SIZE: GameTileSize = { mobile: 130, tablet: 195 };

export const gameImageSrcSets = (url: string, tileSize: GameTileSize = DEFAULT_GAME_TILE_SIZE) => {
    if (typeof url !== 'string' || !url) {
        return { srcSet: '', sizes: '' };
    }

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return { srcSet: '', sizes: '' };
    }

    const widths = Array.from(
        new Set([tileSize.mobile, tileSize.mobile * 2, tileSize.tablet, tileSize.tablet * 2])
    ).sort((a, b) => a - b);

    const srcSet = widths
        .map((w) => {
            parsed.searchParams.set('auto', 'format,compress');
            parsed.searchParams.set('w', String(w));
            parsed.searchParams.delete('h');
            return `${parsed.toString()} ${w}w`;
        })
        .join(', ');

    const sizes = `(min-width: ${TABLET_BREAKPOINT}px) ${tileSize.tablet}px, ${tileSize.mobile}px`;

    return { srcSet, sizes };
};
